import script from "./AppPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPopup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__